export interface Payment {
  id: number;
  externalId: string;
  status: string;
  amount: number;
  currencyId: number;
  paymentMethodId: number;
  dateCreated: string;
  datePaid: string;
  details: any;
}

export interface InvoiceItem {
  id: number;
  invoiceItemType: string;
  name: string;
  amount: number;
  description: string | null;
  displayOrder: number;
}

export interface Invoice {
  id: number;
  invoiceNumber: string;
  invoiceType: string;
  status: string;
  amount: number;
  amountPending: number;
  amountPaid: number;
  currencyId: number;
  description: string | null;
  dateCreated: string;
  datePaid: string;
  dateDue: string;
  dateBillingPeriodStart: string | null;
  dateBillingPeriodEnd: string | null;
  invoiceItems: InvoiceItem[];
  payments: Payment[];
}

export interface Subscription {
  id: number;
  status: string;
  billingInterval: string;
  billingIntervalCount: number;
  dateNextBilling: string;
  dateStart: string;
  dateEnd: string | null;
  dateCanceled: string | null;
}

export interface OrderItem {
  id: number;
  productId: number;
  productTypeId: number;
  name: string;
  price: number;
  subscription: Subscription;
}

export interface MyOrderListModel {
  id: number;
  orderNumber: string;
  status: string;
  totalPrice: number;
  datePaid: string;
  dateCreated: string;
  orderItems: OrderItem[];
  invoices: Invoice[];
  networkType: any;
}
import { UserTicketsModel } from '../../types/loginTypes';
import { UserVirtualOfficeLicence } from '../Settings/settings.types';

export interface GetMyPackageInfoResponse {
  orders: MyOrderListModel[];
}

export interface PackageModel {
  benefits: any;
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number;
  volumePoints: number;
  type: number;
  tickets: string | number;
  subtitle2: string;
}

export interface GetPackagesResponse {
  packages: PackageModel[];
}

export interface UserPackageModel {
  id: number;
  price: number;
  shoppingPoints: number;
  donationPoints: number;
  teamBonusPercent: number;
  status: number;
  dateCreated: string;
  datePaid: string;
  networkType: number;
  paymentAddress: string;
  currencyType: number;
  networkCurrencyType: string;
  depositedUsdtAmount?: number;
  depositedCurrencyAmount?: number;
  depositedTokenCurrency?: string;
  mintedAmount?: number;
  mintedTokenCurrency?: string;
  isActive?: boolean;

  package: {
    packageId: number;
    name: string;
    title?: string;
    price: number;
    teamBonusPercent: number;
    order: number;
    stakeRatio: number;
    weekCapRuleLimit: number;
    volumePoints: number;
    type: number;
    maxDepositAmount?: number;
  };
  packageRank: {
    packageRankId: number;
    name: string;
  };
  nextPackageRank: {
    packageRankId: number;
    name: string;
  };
}

export interface Subscription {
  id: number;
  price: number;

  dateCreated: string; // ISO string format for dates
  dateEnd: string | null;
  datePaid: string | null;
  networkType: number;
  paymentAddress: string;
  currencyType: number;
  networkCurrencyType: number;
}

export interface AddPackageForUserResponse {
  userPackage: UserPackageModel;
  userTickets: UserTicketsModel;
  userVirtualOfficeLicence: UserVirtualOfficeLicence | null;
  subscription?: Subscription | null;
}

export interface MergedPackageModel extends PackageModel {
  id: number;
  image: string;
  title: string;
  price: number;
  weeklyCap: string;
  orderPlan: string;
  ranking: string;
  benefits: Benefit[];
  bonuses: Bonus[];
  firstGift: string;
  proRankBoost: number;
  calculator: string;
  limitedQuantity: boolean;

  dobuleTradingBinaries: number | string;
  membershipBenefits: string[];
  extraTools: string[];
}

export interface TradingPackageModel {
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number;
  volumePoints: number;
  type: number;
  image: string;
  dobuleTradingBinaries: number | string;
  membershipBenefits: string[];
  extraTools: string[];
}

export interface BigWhalePackageModel {
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number | null;
  volumePoints: number;
  type: number;
  isPromo: boolean;
  image: string;
  benefits: string[];
}

interface Benefit {
  icon: number;
  text: string;
}

interface Bonus {
  icon: number;
  text: string;
}

export enum PurchaseSteps {
  INITIAL = 1,
  PAYMENT_METHOD,
  PAY_MIXED,
  PAY_TETHER,
  SUCCESS
}

export enum Tokens {
  TETHER,
  USDC
}

export enum TokenCurrencyType {
  TETHER = 1,
  USDC = 7
}
